module.exports = __webpack_public_path__ + "static/media/dontcopy1.a0d98830.gif";